import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Session } from "@supabase/supabase-js";

interface NavLinksProps {
  session: Session | null;
  handleAuthClick: () => void;
}

export const NavLinks = ({ session, handleAuthClick }: NavLinksProps) => {
  return (
    <>
      <Link
        to="/documentation"
        className="text-gray-300 hover:text-white transition-colors"
      >
        Documentation
      </Link>
      <Link
        to="/pricing"
        className="text-gray-300 hover:text-white transition-colors"
      >
        Pricing
      </Link>
      {session && (
        <>
          <Link
            to="/support"
            className="text-gray-300 hover:text-white transition-colors"
          >
            Support
          </Link>
          <Link
            to="/status"
            className="text-gray-300 hover:text-white transition-colors"
          >
            Status
          </Link>
        </>
      )}
      <Button
        onClick={handleAuthClick}
        className="bg-gradient-to-r from-skuhub-coral to-skuhub-orange text-white hover:opacity-90 transition-opacity"
      >
        {session ? "Dashboard" : "Login"}
      </Button>
    </>
  );
};